<div *ngIf="isOpen" class="fixed inset-0 z-50 overscroll-none touch-none">
    <div class="fixed inset-0 bg-slate-950/65" (click)="onClose()"></div>

    <aside class="fixed inset-y-0 right-0 flex w-[min(24rem,100vw)] touch-pan-y flex-col overscroll-contain border-l border-app-highlight-line bg-app-surface-warm shadow-panel-left"
        [ngStyle]="{ 'font-size': fontSize }" aria-label="通知中心">
        <header class="border-b border-app-accent-dark bg-app-accent px-4 pb-4 pt-[calc(1rem+env(safe-area-inset-top,0px))] text-white">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                    <span class="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/30 bg-app-accent-active">
                        <i class="bi bi-bell-fill app-icon" aria-hidden="true"></i>
                    </span>
                    <div>
                        <h2 class="app-section-title">通知中心</h2>
                        <p class="mt-0.5 text-xs text-white/75">
                            {{ personalNotifications.length > 0 ? personalNotifications.length + ' 則未讀通知' : '沒有未讀通知' }}
                        </p>
                    </div>
                </div>
                <button type="button" class="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/35"
                    (click)="onClose()" aria-label="關閉通知">
                    <i class="bi bi-x-lg app-icon" aria-hidden="true"></i>
                </button>
            </div>
        </header>

        <div *ngIf="personalNotifications.length > 0" class="border-b border-app-highlight-line bg-app-highlight-soft px-4 py-3">
            <button type="button"
                class="flex min-h-11 w-full items-center justify-center gap-2 rounded-lg border border-app-highlight-border bg-white px-4 py-2 font-semibold text-app-highlight-dark"
                (click)="onReadAllNotifications()">
                <i class="bi bi-check2-all app-icon" aria-hidden="true"></i>
                全部標示為已讀
            </button>
        </div>

        <div class="min-h-0 flex-1 touch-pan-y overflow-y-auto overscroll-contain p-3 sm:p-4">
            <div *ngIf="personalNotifications.length > 0" class="space-y-3">
                <button *ngFor="let notification of personalNotifications" type="button"
                    class="block w-full whitespace-normal rounded-lg border border-app-border bg-white text-left shadow-app-sm"
                    (click)="onClickNotification(notification)">
                    <div class="flex items-start gap-3 p-4">
                        <span class="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md"
                            [ngClass]="getNotificationBgClass(notification.notification_type)">
                            <i [class]="'bi app-icon text-lg ' + getNotificationIcon(notification.notification_type)" aria-hidden="true"></i>
                        </span>
                        <span class="min-w-0 flex-1">
                            <span class="flex flex-wrap items-start justify-between gap-x-3 gap-y-1">
                                <strong class="whitespace-normal leading-snug text-slate-900" [ngStyle]="{ 'font-size': getTitleFontSize() }">
                                    {{ notification.title }}
                                </strong>
                                <span class="app-numeric flex-shrink-0 text-slate-500" [ngStyle]="{ 'font-size': getSmallFontSize() }">
                                    {{ getFormattedTime(notification.created_at) }}
                                </span>
                            </span>
                            <span class="mt-2 block whitespace-normal leading-relaxed text-slate-600" [ngStyle]="{ 'font-size': getDescriptionFontSize() }">
                                {{ notification.description }}
                            </span>
                            <span class="mt-3 flex items-center justify-between gap-3 border-t border-slate-200 pt-2">
                                <span class="flex items-center gap-2 text-slate-500" [ngStyle]="{ 'font-size': getSmallFontSize() }">
                                    <span class="h-2 w-2 flex-shrink-0 rounded-sm" [ngClass]="getNotificationStatusClass(notification.notification_type)" aria-hidden="true"></span>
                                    {{ getNotificationActionText(notification) }}
                                </span>
                                <i class="bi bi-chevron-right app-icon flex-shrink-0 text-slate-400" aria-hidden="true"></i>
                            </span>
                        </span>
                    </div>
                </button>
            </div>

            <div *ngIf="personalNotifications.length === 0 && isLogin" class="flex min-h-64 flex-col items-center justify-center px-4 py-10 text-center">
                <span class="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-lg border border-app-brand-border-soft bg-app-brand-wash text-app-brand">
                    <i class="bi bi-bell-slash app-icon text-2xl" aria-hidden="true"></i>
                </span>
                <h3 class="font-bold text-slate-800" [ngStyle]="{ 'font-size': getEmptyStateTitleFontSize() }">目前沒有通知</h3>
                <p class="mt-2 text-slate-500" [ngStyle]="{ 'font-size': getEmptyStateDescFontSize() }">新的任務與交易通知會顯示在這裡</p>
            </div>

            <div *ngIf="!isLogin" class="flex min-h-64 flex-col items-center justify-center px-4 py-10 text-center">
                <span class="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-lg border border-app-highlight-line bg-app-highlight-soft text-app-highlight-text">
                    <i class="bi bi-lock-fill app-icon text-2xl" aria-hidden="true"></i>
                </span>
                <h3 class="font-bold text-slate-800" [ngStyle]="{ 'font-size': getEmptyStateTitleFontSize() }">需要登入</h3>
                <p class="mt-2 text-slate-500" [ngStyle]="{ 'font-size': getEmptyStateDescFontSize() }">登入後即可查看個人通知</p>
                <button type="button" class="app-brand-button mt-5 min-h-12 rounded-lg px-6 py-3 font-semibold"
                    [ngStyle]="{ 'font-size': getButtonFontSize() }" (click)="onLoginPage()">前往登入</button>
            </div>
        </div>
    </aside>
</div>

<app-alert [show]="!!notificationMessage && showAlert" [message]="notificationMessage" [type]="'warning'"
    [fontSize]="parseFontSize(fontSize)" (closed)="closeAlert()">
</app-alert>
